"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const antd_1 = require("complex-component/antd");
const OverdueDetail_vue_1 = __importDefault(require("@/pages/index/components/OverdueDetail.vue"));
const plugin_1 = require("@/plugin");
const mainData_1 = __importDefault(require("./../mainData"));
const overdue_1 = __importDefault(require("@/pages/index/api/overdue"));
const file_1 = require("@/pages/index/utils/file");
const guarantorPath = '/overdue/guarantor/list';
let fromPath = '';
exports.default = (0, vue_1.defineComponent)({
    name: 'GuarantorInfo',
    components: {
        OverdueDetail: OverdueDetail_vue_1.default,
        ComplexEditForm: antd_1.ComplexEditForm
    },
    data() {
        return {
            mainData: mainData_1.default,
            detail: null
        };
    },
    beforeRouteEnter(to, from) {
        // 在渲染该组件的对应路由被验证前调用
        // 不能获取组件实例 `this` ！
        // 因为当守卫执行时，组件实例还没被创建！
        fromPath = from.fullPath !== '/' ? from.fullPath : '';
    },
    computed: {
        id() {
            return this.$route.params.id === 'build' ? undefined : this.$route.params.id;
        },
        width() {
            return this.getWidth();
        },
        isOperating() {
            return this.mainData.$getStatus('operate') === 'ing';
        },
        isContent() {
            return this.hasContent();
        },
        isAttachment() {
            return this.hasAttachment();
        }
    },
    watch: {
        id() {
            this.$nextTick(() => {
                this.init('watch');
            });
        }
    },
    mounted() {
        this.init('mounted');
    },
    methods: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        init(from) {
            this.detail = null;
            const editForm = this.$refs['edit-form'];
            if (this.id) {
                (0, file_1.getFileWithPromise)(overdue_1.default.overdueGuarantorInfo.require({
                    id: this.id
                }), this.id).then(res => {
                    const detail = this.mainData.$createDataByDictionary(res.data);
                    detail.uploadFileList = [];
                    detail.attachmentList = [];
                    if (res.file) {
                        res.file.forEach(item => {
                            if (item.data.bizType === 'guarantorFile') {
                                detail.uploadFileList.push(item);
                            }
                            else if (item.data.bizType === 'guarantorAttachment') {
                                detail.attachmentList.push(item);
                            }
                        });
                    }
                    this.detail = detail;
                    editForm.show('change', 'change', this.detail);
                    editForm.pageList.data.forEach(item => {
                        if (item.prop === 'attachmentList') {
                            if (this.hasAttachment()) {
                                // 有附件编辑权限
                                editForm.pageList.show('attachmentList');
                            }
                            else {
                                editForm.pageList.hidden('attachmentList');
                            }
                        }
                        else if (item.prop !== 'uploadFileList') {
                            item.disabled.setData('change', !this.hasContent());
                        }
                    });
                });
            }
            else {
                editForm.show('build', 'build');
            }
        },
        hasContent() {
            if (this.detail && this.detail.signMethod.value === 'QI_YUE_SUO') {
                if (this.detail.guarantorStatus.value === 'DRAFT') {
                    return true;
                }
                else {
                    return false;
                }
            }
            else {
                return false;
            }
        },
        hasAttachment() {
            if (this.detail && ['AUDIT_SUCCEED', 'SUCCEED'].indexOf(this.detail.guarantorStatus.value) > -1) {
                return true;
            }
            else {
                return false;
            }
        },
        getWidth() {
            return plugin_1.reactiveLayout.data.main.width - 16 * 2;
        },
        backToFrom(toFrom) {
            if (fromPath && toFrom) {
                // 存在来源路径切需要跳转回来源时，通过back回退
                this.$router.back();
            }
            else {
                this.$router.push(guarantorPath);
            }
        },
        onSave(attachment) {
            this.$refs['edit-form'].handle((targetData, originData, type) => {
                if (attachment) {
                    this.mainData.$triggerMethod('saveAttachment', [targetData, this.$route.params.overdueRecordId, originData], true).then(() => {
                        this.backToFrom();
                    });
                }
                else if (type === 'change') {
                    this.mainData.$triggerMethod('changeItem', [targetData, this.$route.params.overdueRecordId, originData], true).then(() => {
                        this.backToFrom();
                    });
                }
                else if (type === 'build') {
                    this.mainData.$triggerMethod('buildItem', [targetData, this.$route.params.overdueRecordId, originData], true).then(() => {
                        this.backToFrom(true);
                    });
                }
            });
        }
    }
});
